<script setup lang="ts">
const { colors } = useTheme()
</script>

<template>
  <svg width="161" height="159" viewBox="0 0 161 159" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="161" height="159" fill="none" />
    <g opacity="0.75" filter="url(#filter0_d_4766_60622)">
      <path d="M72.9 102.5L102.15 83.75C103.55 82.85 104.25 81.6 104.25 80C104.25 78.4 103.55 77.15 102.15 76.25L72.9 57.5C71.4 56.5 69.874 56.424 68.322 57.272C66.77 58.12 65.996 59.446 66 61.25V98.75C66 100.55 66.776 101.876 68.328 102.728C69.88 103.58 71.404 103.504 72.9 102.5ZM81 140C72.7 140 64.9 138.424 57.6 135.272C50.3 132.12 43.95 127.846 38.55 122.45C33.15 117.05 28.876 110.7 25.728 103.4C22.58 96.1 21.004 88.3 21 80C21 71.7 22.576 63.9 25.728 56.6C28.88 49.3 33.154 42.95 38.55 37.55C43.95 32.15 50.3 27.876 57.6 24.728C64.9 21.58 72.7 20.004 81 20C89.3 20 97.1 21.576 104.4 24.728C111.7 27.88 118.05 32.154 123.45 37.55C128.85 42.95 133.126 49.3 136.278 56.6C139.43 63.9 141.004 71.7 141 80C141 88.3 139.424 96.1 136.272 103.4C133.12 110.7 128.846 117.05 123.45 122.45C118.05 127.85 111.7 132.126 104.4 135.278C97.1 138.43 89.3 140.004 81 140Z" :fill="colors.white" />
    </g>
    <defs>
      <filter id="filter0_d_4766_60622" x="5" y="4" width="152" height="152" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4766_60622" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4766_60622" result="shape" />
      </filter>
    </defs>
  </svg>
</template>
